module.exports = __webpack_public_path__ + "media/Video 122.25a7f941.mp4";